
import { getInsuredInfo } from '@/model/javaApi/present.js'
import { customer } from '@/utils/customer/index.js'
import Cell from 'vux/src/components/cell/index.vue'

import  InTitle  from '@/views/stencil/components/title'
import  UseInfo  from '@/views/stencil/components/useInfo'
import  List  from '@/views/stencil/components/list'
import  TimeLine  from './components/TimeLine'
import { getAppClient } from '@/utils/commonUtils';
import { store } from "@/observable/store";
export default {
name:'insureStatus',
data(){
return{
modeShow:false,
insureFields:[
{insureName:'保险产品',insureVal:'commodityName'},{insureName:'保障责任',insureVal:''},
{insureName:'保险费用',insureVal:'actualPay'},{insureName:'保险公司',insureVal:'companyName'}
],
insuredInfo:{},
claimData:{
claimTitle:'理赔说明',
claimDetail:''
},
schemeServiceInfos:[], //保障内容
source: getAppClient() == 'APP' ? 'sy_app_my_bx_manger' : 'sy_wechat_jbx_ymz_my_claims'
}
},
computed:{
uid() {
return store.uid;
},

orderNo(){
return this.$route.query.orderNo
},

channelCommodityCode(){
return this.$route.query.channelCommodityCode
},

baseNo(){
return this.$route.query.baseNo
}
},

components:{
UseInfo,
List,
TimeLine,
Cell,
InTitle
},
created(){
this.getInfo();

this.AppSetTitleBar('安心美',["refresh"]);

},
mounted () {
this.STATISTICS_CONFIG.insur_insurestatus_page()
},
methods:{
getInfo(){
console.log('进入获取详情')


const data = {
channelCommodityCode:this.channelCommodityCode,
mainOrderNo:this.orderNo,
baseOrderNo:this.baseNo
}
getInsuredInfo(data).then(res =>{
this.insuredInfo = res;
try {
this.insureFields= this.insuredInfo.securityInfo.map(item=>{
if(item.insureName ==='保障责任'){
item.insureVal=item.insureVal.replace(/,/g, '<br/>');
}
return item
});
} catch (e) {
console.log('错误',e)
}

this.$set(this.claimData,'claimDetail',res.claimDetail)
console.log('理赔',this.claimData)

res.schemeServiceInfos.forEach(item =>{
let obj = {setTitle:item.content,setContent:item.description}
this.schemeServiceInfos.push(obj)
})
})
},

insureInfo(){
this.STATISTICS_CONFIG.insur_insurestatus_insurdetail_click()
this.modeShow = true
},

custUrl(){
this.STATISTICS_CONFIG.insur_insurestatus_contactonline_click()

window.location.href = `https://chic.soyoung.com/sys/html/cooperation/jump_ud.html?uid=${
this.uid
}&source=${this.source}&pid=null&timestamp=${Date.now()}`;
}
}
}
